module.exports = __webpack_public_path__ + "static/logoCSB-3e105cc577f31e3ef3b7a35189926959.png";